<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title11"></a>
<div class="toc_entry"><a class="toc_entry_frontMatter" href="#/9781459263314_fm01"><span><em class="i"><strong class="b">“You can’t deny what’s between us—”</strong></em></span></a><br/>
<a class="toc_entry_aboutAuthorPage" href="#/9781459263314_ata01"><span>About the Author</span></a><br/>
<a class="toc_entry_alsoby" href="#/9781459263314_als01"><span>Also by</span></a><br/>
<a class="toc_entry_titlePage" href="#/9781459263314_tp01"><span>Title Page</span></a><br/>
<a class="toc_entry_chapter" href="#/9781459263314_c01"><span><strong class="b">CHAPTER ONE</strong></span></a><br/>
<span class="toc_entry_chapter" href="#/9781459263314_c02" title="Link target outside of Sample"><span><strong class="b">CHAPTER TWO</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459263314_c03" title="Link target outside of Sample"><span><strong class="b">CHAPTER THREE</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459263314_c04" title="Link target outside of Sample"><span><strong class="b">CHAPTER FOUR</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459263314_c05" title="Link target outside of Sample"><span><strong class="b">CHAPTER FIVE</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459263314_c06" title="Link target outside of Sample"><span><strong class="b">CHAPTER SIX</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459263314_c07" title="Link target outside of Sample"><span><strong class="b">CHAPTER SEVEN</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459263314_c08" title="Link target outside of Sample"><span><strong class="b">CHAPTER EIGHT</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459263314_c09" title="Link target outside of Sample"><span><strong class="b">CHAPTER NINE</strong></span></span><br/>
<span class="toc_entry_pubInfo" href="#/9781459263314_cop01" title="Link target outside of Sample"><span>Copyright</span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459263314_toc01.vue?106580dd